<script setup lang="ts">
import FeatureFlag from '@frontend/common/feature-flag.vue';
import MisSecciones from '@frontend/secciones/components/mis-secciones.vue';
</script>

<template>
  <feature-flag name="secciones">
    <template #funcionalidadHabilitada>
      <mis-secciones />
    </template>
  </feature-flag>
</template>
